import React from 'react';
import {connect} from 'react-redux';

import {arrayMove} from "../../utilities/helpers";
import DiscountsSortableItems from "./discountsSortableItems";
import {setDiscountSections} from "./discountsActions";
import DiscountsFinancing from "./DiscountsFinancing";
import {DISCOUNT_SECTION_TYPES} from "./discountsInterface";
import {getCurrentWorkSheetSections} from "./discountsFunctions";

class DiscountsBody extends React.Component {

  shouldCancelStart = (event) => {
    const excludedClassNames = ["discount-name", "ui-svg-checkbox", "employees-checkbox-circle",
      "discount-type", "radio", "discount-amount", "ui-icon-remove", "discounts-header__buttons-item", "select3"];
    if (excludedClassNames.some(className => {
      return event.target.classList.contains(className) || event.target.closest("."+className)
    })) {
      return true
    }
  };

  onSortStart = ({node}) => {
    const discountNode = node.closest(".discount");
    const sectionIndex = discountNode && discountNode.dataset.section;
    // console.log("sectionIndex", sectionIndex);
    window.draggingDiscountSection = +sectionIndex;
    window.draggingDiscountId = discountNode ? discountNode.dataset.id : null;
  };

  onSortEnd = ({ oldIndex, newIndex, collection}, e) => {

    if (!window.draggingDiscountId) {
      return
    }

    // console.log("window.draggingDiscountSection", window.draggingDiscountSection);
    // console.log("collection", collection);
    // console.log("oldIndex", oldIndex);
    // console.log("newIndex", newIndex);
    const closestSection = e.target.closest(".discounts-section");
    const sortEndSectionOrder = closestSection && +closestSection.dataset.order;
    // console.log("sortEndSectionOrder", sortEndSectionOrder);
    if (sortEndSectionOrder || sortEndSectionOrder === 0) {
      if (sortEndSectionOrder === window.draggingDiscountSection) { // same section
        if (oldIndex !== newIndex) {
          this.props.setDiscountSections(this.props.discountSections.map(discountSection => {
            if (discountSection.order === sortEndSectionOrder) {
              discountSection.discounts = arrayMove(discountSection.discounts, oldIndex, newIndex)
                .map((discount, discountIndex) => {
                  discount.order = discountIndex;
                  return discount
                });
            }
            return discountSection
          })); //update on frontend
        }
      } else {  // different section
        let draggedDiscount = null;
        let nestedChildren = [];
        this.props.discountSections.forEach(currentSection => {
          currentSection.discounts.forEach(dis => {
            if (dis.id + "" === window.draggingDiscountId) {
              draggedDiscount = dis;
              nestedChildren = currentSection.discounts.filter((dis) => {
                return dis.nestedParent && dis.nestedParent === draggedDiscount.uuId;
              });
            }
          })
        });
        const sortEndDiscount = e.target.closest(".discount");
        const newDiscountOrder = (sortEndDiscount && +sortEndDiscount.dataset.order > -1)
          ? +sortEndDiscount.dataset.order + 1
          : 0;
        const newSections = this.props.discountSections
          .map((currentSection) => {
            if (currentSection.order === sortEndSectionOrder) { // 1) push discount to new section
              currentSection.discounts.splice(newDiscountOrder, 0, draggedDiscount);
              if (nestedChildren && nestedChildren.length) {
                nestedChildren.forEach((dis, disIndex) => {
                  currentSection.discounts.splice(newDiscountOrder + disIndex + 1, 0, dis);
                })
              }
            } else { // 2) delete discount from old section
              currentSection.discounts = currentSection.discounts.filter((dis) => {
                return dis.id !== draggedDiscount.id && (!dis.nestedParent || dis.nestedParent !== draggedDiscount.uuId);
              })
            }
            return currentSection
          })
          .map((currentSection) => {
            currentSection.discounts = currentSection.discounts.map((discount, discountIndex) => {
              discount.order = discountIndex;
              return discount
            });
            return currentSection
          });
        this.props.setDiscountSections(newSections);
      }
    }

    window.draggingDiscountSection = -1; // reset dragging key
    window.draggingDiscountId = null;
  };

  render() {
    console.log("this.props.discountSections", this.props.discountSections);
    const {discountSections, workSheetsActiveIndex} = this.props;
    const currentSheetSections = getCurrentWorkSheetSections(discountSections, workSheetsActiveIndex);
    const discountExist = currentSheetSections.some(sec => sec.discounts.length);

    return this.props.discountsReceived ? (
      <div className="discounts-body">
        {currentSheetSections.length ? (
          <DiscountsSortableItems discountsList={this.props.discounts}
                                  discountSections={currentSheetSections}
                                  onSortEnd={this.onSortEnd}
                                  onSortStart={this.onSortStart}
                                  shouldCancelStart={this.shouldCancelStart}/>
        ) : null}
        {discountExist ? <DiscountsFinancing/> : null}
        {!discountExist ? (
          <div className="discounts-body discounts-body--empty">No items added yet</div>
        ) : null}
      </div>
    ) : (
      <div style={{height: "200px"}}>
        <div className="ui-loader"/>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  const {discountsReceived, discountSections, workSheetsActiveIndex} = store.discountsState;
  return {
    discountsReceived,
    discountSections,
    workSheetsActiveIndex,
  };
};

const mapDispatchToProps = {
  setDiscountSections,
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountsBody);
